// Shown wherever a filtered view has nothing to display. Matches the app's card
// language (soft icon badge, muted copy) instead of a plain emoji.
export function EmptyState({ message = 'No data for the selected filters.' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-14 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-100 text-slate-400 dark:bg-white/10 dark:text-slate-500">
        <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M4 13V8.4a1 1 0 01.55-.9l7-3.5a1 1 0 01.9 0l7 3.5a1 1 0 01.55.9V13M4 13l8 4M4 13l8-4M20 13l-8 4M20 13l-8-4M12 21v-8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <p className="max-w-xs text-sm text-slate-400 dark:text-slate-500">{message}</p>
    </div>
  );
}
